import { useTheme } from '@repo/ui';
import type { CSSProperties } from 'react';
import { Toaster } from 'sonner';

/** Clears the pinned footer bar (Assign, Save marks, Submit), which sits at the bottom of the page. */
const FOOTER_CLEARANCE_PX = 96;

/** Long enough to read on a phone, short enough not to sit over the next action. */
const TOAST_DURATION_MS = 4000;

const TOAST_COLOURS = {
  '--normal-bg': 'var(--popover)',
  '--normal-text': 'var(--popover-foreground)',
  '--normal-border': 'var(--border)',
  '--success-bg': 'var(--popover)',
  '--success-text': 'var(--popover-foreground)',
  '--success-border': 'var(--success)',
  '--error-bg': 'var(--popover)',
  '--error-text': 'var(--popover-foreground)',
  '--error-border': 'var(--destructive)',
} as CSSProperties;

/**
 * One toast at a time, bottom-right so it never covers a header action, in the app's own
 * surface colours rather than the library's tinted ones, whose text is hard to read.
 * The toast region is a polite live region, so a screen reader hears each message.
 */
export function AppToaster() {
  const { theme } = useTheme();

  return (
    <Toaster
      theme={theme}
      position="bottom-right"
      visibleToasts={1}
      duration={TOAST_DURATION_MS}
      offset={{ bottom: FOOTER_CLEARANCE_PX }}
      mobileOffset={{ bottom: FOOTER_CLEARANCE_PX }}
      style={TOAST_COLOURS}
    />
  );
}
